import { FC, useEffect } from 'react';

import { Assets } from '@assets';
import { ModalBodyContainer } from '@components';
import { Button } from '@elements/button';
import { Text } from '@elements/text';
import { i18n } from '@i18n';
import { useBoostDetailsStore } from '@store';
import { sendAnalyticsEvent, testProps } from '@utils';

export interface EMCCancelModalProps {
  primaryAction: () => void;
  secondaryAction: () => void;
}

export const EMCCancel: FC<EMCCancelModalProps> = ({ primaryAction, secondaryAction }) => {
  const emcDeclaring = useBoostDetailsStore(state => state.emcDeclaring);

  const handleCancel = () => {
    secondaryAction();
    sendAnalyticsEvent('Medical assessment cancelled', {
      TravellerID: emcDeclaring?.travellerId ?? '',
    });
  };

  useEffect(() => {
    sendAnalyticsEvent('Cancel medical assessment modal opened', {
      TravellerID: emcDeclaring?.travellerId ?? '',
    });
  }, [emcDeclaring?.travellerId]);

  return (
    <ModalBodyContainer
      icon={<Assets.AlertOutline />}
      header={<Text variant="h3-28/sb">{i18n.t('emcShared.global.modal.cancel.title')}</Text>}
      description={
        <Text variant="body-16/r">{i18n.t('emcShared.global.modal.cancel.description')}</Text>
      }
      buttons={
        <div className="flex flex-col w-full md:flex-row my-2 gap-4">
          <Button
            variant="secondary"
            className="w-full"
            onClick={primaryAction}
            title={i18n.t('emcShared.global.modal.cancel.actions.primary')}
            {...testProps('btn-back')}
          />

          <Button
            variant="primary"
            className="w-full"
            onClick={handleCancel}
            title={i18n.t('emcShared.global.modal.cancel.actions.secondary')}
            {...testProps('btn-submit')}
          />
        </div>
      }
    />
  );
};
